import { lazy, Suspense, useEffect, useState } from "react";

const CookieConsent = lazy(() =>
  import("./CookieConsent").then((m) => ({ default: m.CookieConsent }))
);
const Toaster = lazy(() =>
  import("@/components/ui/sonner").then((m) => ({ default: m.Toaster }))
);

/**
 * Defers loading of non-critical client-only chrome (cookie banner, toaster)
 * until the browser is idle. Keeps these out of the initial JS chunk.
 */
export function LazyClientChrome() {
  const [ready, setReady] = useState(false);

  useEffect(() => {
    if (typeof window === "undefined") return;
    const w = window as Window & {
      requestIdleCallback?: (cb: () => void, opts?: { timeout: number }) => number;
    };
    let timer: number | undefined;
    if (typeof w.requestIdleCallback === "function") {
      w.requestIdleCallback(() => setReady(true), { timeout: 2500 });
    } else {
      timer = window.setTimeout(() => setReady(true), 1500);
    }
    return () => {
      if (timer) window.clearTimeout(timer);
    };
  }, []);

  if (!ready) return null;
  return (
    <Suspense fallback={null}>
      <CookieConsent />
      <Toaster />
    </Suspense>
  );
}
